<script setup lang="ts">
import { useSearchStore } from '../../store/index'
import StandardsSearchInputArea from './StandardsSearchInputArea.ce.vue';
import StandardsSearchFilters from './StandardsSearchFilters.ce.vue';
const searchStore = useSearchStore()
const { getItem } = searchStore

//props
const props = defineProps({
    showFilters: { type: Boolean, default: true },
    forMobile: { type: Boolean, default: false }
})

</script>

<template>
    <div class="search-bar--standards">
        <StandardsSearchInputArea :forMobile="forMobile"></StandardsSearchInputArea>
        <StandardsSearchFilters v-show="showFilters && getItem('standards.displayMoreSearchBarFilters')"></StandardsSearchFilters>
    </div>
</template>